import React from 'react'

const SvgAmaisNegativo = props => (
	<svg id='amais-negativo_svg__Logo' width={112.313} height={50} {...props}>
		<defs>
			<style>{'.amais-negativo_svg__cls-1{fill:#fff}.amais-negativo_svg__cls-2{fill:#343838}'}</style>
		</defs>
		<path
			id='amais-negativo_svg__Caminho_101'
			d='M193.179 107.145h-.986v-2.995a1.3 1.3 0 00-.221-.929.948.948 0 00-.748-.292 1.036 1.036 0 00-.809.331 1.581 1.581 0 00-.259 1.06v2.825h-.989v-2.995a1.3 1.3 0 00-.223-.929.944.944 0 00-.746-.292 1.033 1.033 0 00-.809.331 1.562 1.562 0 00-.26 1.06v2.825h-.987v-4.165h-.575v-.727h1.165l.184.575a1.961 1.961 0 012.995.062 1.692 1.692 0 011.483-.726 1.8 1.8 0 011.423.545 1.9 1.9 0 01.361 1.29z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 101'
			transform='translate(-121.98 -84.149)'
		/>
		<path
			id='amais-negativo_svg__Caminho_102'
			d='M195.216 102.859c-.625 0-1.068.445-1.149 1.512h2.179l.087-.1c0-.858-.37-1.413-1.117-1.413m1.927 2.036a.659.659 0 01-.475.132h-2.6a1.4 1.4 0 001.462 1.493 2.914 2.914 0 001.555-.475l-.044.756a3.134 3.134 0 01-1.672.435 2.216 2.216 0 01-2.31-2.512c0-1.583.838-2.561 2.178-2.561a2.026 2.026 0 012.047 2.279.619.619 0 01-.141.453'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 102'
			transform='translate(-120.879 -84.149)'
		/>
		<path
			id='amais-negativo_svg__Caminho_103'
			d='M200.636 103.164a2.728 2.728 0 00-.643-.081c-1.029 0-1.645.677-1.645 2.019 0 .968.374 1.664 1.18 1.664a1.1 1.1 0 00.846-.343 1.446 1.446 0 00.262-1zm1.554 4.074a1.191 1.191 0 01-.707.2.838.838 0 01-.664-.251l-.123-.223a1.652 1.652 0 01-1.279.515c-1.313 0-2.069-.867-2.069-2.35a2.805 2.805 0 01.756-2.077 2.566 2.566 0 011.817-.646 3.3 3.3 0 01.715.078v-1.269h-.574v-.726h1.564v5.94c0 .231.068.322.24.322a.744.744 0 00.364-.119z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 103'
			transform='translate(-120.248 -84.395)'
		/>
		<path
			id='amais-negativo_svg__Caminho_104'
			d='M202.992 101.717a.59.59 0 01-.583-.6.578.578 0 01.583-.583.586.586 0 01.6.583.6.6 0 01-.6.6m1.119 5.515a1.182 1.182 0 01-.7.2.847.847 0 01-.669-.251 1.1 1.1 0 01-.181-.736v-3.228h-.573v-.727h1.562v3.934c0 .231.071.322.242.322a.744.744 0 00.364-.119z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 104'
			transform='translate(-119.567 -84.388)'
		/>
		<path
			id='amais-negativo_svg__Caminho_105'
			d='M207.518 103.817c-.141-.606-.4-.95-.938-.95-.827 0-1.169.768-1.169 1.766 0 1.271.462 1.887 1.411 1.887a2.659 2.659 0 001.433-.465l-.04.757a2.937 2.937 0 01-1.553.423c-1.444 0-2.249-.9-2.249-2.532 0-1.593.827-2.54 2.159-2.54a1.75 1.75 0 011.865 1.451z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 105'
			transform='translate(-119.21 -84.149)'
		/>
		<path
			id='amais-negativo_svg__Caminho_106'
			d='M209.359 101.717a.591.591 0 01-.586-.6.579.579 0 01.586-.583.585.585 0 01.6.583.6.6 0 01-.6.6m1.122 5.515a1.2 1.2 0 01-.708.2.839.839 0 01-.665-.251 1.092 1.092 0 01-.182-.736v-3.228h-.575v-.727h1.562v3.934c0 .231.07.322.243.322a.752.752 0 00.364-.119z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 106'
			transform='translate(-118.631 -84.388)'
		/>
		<path
			id='amais-negativo_svg__Caminho_107'
			d='M215.315 107.145h-.989v-2.995a1.308 1.308 0 00-.223-.929.969.969 0 00-.777-.292 1.081 1.081 0 00-.838.331 1.568 1.568 0 00-.262 1.06v2.825h-.989v-4.165h-.576v-.727h1.171l.181.575a1.743 1.743 0 011.473-.664 1.878 1.878 0 011.464.545 1.9 1.9 0 01.364 1.29z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 107'
			transform='translate(-118.291 -84.149)'
		/>
		<path
			id='amais-negativo_svg__Caminho_108'
			d='M218.526 104.736a3.168 3.168 0 00-.868-.132c-.777 0-1.088.4-1.088.957a.894.894 0 00.927 1 1.064 1.064 0 00.787-.3 1.115 1.115 0 00.243-.794zm1.554 2.257a1.161 1.161 0 01-.7.2.741.741 0 01-.78-.483 1.655 1.655 0 01-1.279.524 1.568 1.568 0 01-1.746-1.636c0-1.109.758-1.684 1.949-1.684a3.591 3.591 0 011 .161v-.138a1.087 1.087 0 00-.214-.78 1.155 1.155 0 00-.916-.312 2.771 2.771 0 00-1.351.364v-.717a3.27 3.27 0 011.493-.331 2.2 2.2 0 011.594.525 1.647 1.647 0 01.381 1.2v2.3c0 .232.072.322.243.322a.728.728 0 00.361-.119z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 108'
			transform='translate(-117.569 -84.149)'
		/>
		<path
			id='amais-negativo_svg__Caminho_109'
			d='M188.968 110.909a2.791 2.791 0 00-.647-.083c-1.028 0-1.644.677-1.644 2.02 0 .967.374 1.662 1.183 1.662a1.1 1.1 0 00.845-.341 1.436 1.436 0 00.263-1zm1.554 4.075a1.2 1.2 0 01-.705.2.842.842 0 01-.666-.252l-.122-.221a1.654 1.654 0 01-1.281.514c-1.31 0-2.067-.867-2.067-2.35a2.8 2.8 0 01.757-2.079 2.562 2.562 0 011.815-.645 3.47 3.47 0 01.716.08v-1.271h-.575v-.727h1.563v5.941c0 .234.07.325.242.325a.75.75 0 00.364-.122z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 109'
			transform='translate(-121.963 -83.257)'
		/>
		<path
			id='amais-negativo_svg__Caminho_110'
			d='M191.324 109.458a.589.589 0 01-.587-.6.579.579 0 01.587-.583.587.587 0 01.6.583.6.6 0 01-.6.6m1.121 5.519a1.207 1.207 0 01-.707.2.844.844 0 01-.666-.252 1.1 1.1 0 01-.184-.737v-3.228h-.571v-.725h1.561v3.932c0 .234.071.325.243.325a.746.746 0 00.361-.122z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 110'
			transform='translate(-121.282 -83.25)'
		/>
		<path
			id='amais-negativo_svg__Caminho_111'
			d='M195.783 112.476a3.235 3.235 0 00-.868-.132c-.776 0-1.088.407-1.088.961a.9.9 0 00.929 1 1.081 1.081 0 00.787-.3 1.126 1.126 0 00.241-.8zm1.554 2.262a1.169 1.169 0 01-.7.2.743.743 0 01-.779-.483 1.66 1.66 0 01-1.278.523 1.568 1.568 0 01-1.747-1.634c0-1.111.756-1.685 1.949-1.685a3.619 3.619 0 011 .162v-.141a1.075 1.075 0 00-.213-.778 1.146 1.146 0 00-.916-.312 2.755 2.755 0 00-1.352.366v-.72a3.282 3.282 0 011.495-.331 2.183 2.183 0 011.592.525 1.645 1.645 0 01.387 1.2v2.3c0 .234.069.325.241.325a.75.75 0 00.362-.122z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 111'
			transform='translate(-120.911 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_112'
			d='M200.543 110.692a2.041 2.041 0 00-.637-.111c-1.028 0-1.653.688-1.653 1.969 0 1.047.392 1.65 1.189 1.65a1.1 1.1 0 00.817-.321 1.273 1.273 0 00.283-.919zm.988 4.1a2.187 2.187 0 01-.445 1.633 2.307 2.307 0 01-1.764.6 3.621 3.621 0 01-1.633-.374l.039-.775a3.192 3.192 0 001.543.435 1.368 1.368 0 00.99-.333 1.616 1.616 0 00.283-1.149v-.417a1.6 1.6 0 01-1.264.494c-1.279 0-2.027-.815-2.027-2.288a2.749 2.749 0 01.787-2.058 2.661 2.661 0 011.887-.656 4.891 4.891 0 011.6.294z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 112'
			transform='translate(-120.262 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_113'
			d='M206.379 114.889h-.99v-3a1.284 1.284 0 00-.221-.926.963.963 0 00-.775-.295 1.066 1.066 0 00-.836.335 1.557 1.557 0 00-.264 1.057v2.825h-.993v-4.167h-.575V110h1.17l.181.572a1.746 1.746 0 011.473-.664 1.6 1.6 0 011.826 1.836z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 113'
			transform='translate(-119.604 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_114'
			d='M209.551 109.225a1.445 1.445 0 00-.373-.057 1.991 1.991 0 00-1.251.553l-.122-.284a2.174 2.174 0 011.434-1.009c.3 0 .464.151.464.385a.8.8 0 01-.153.413m-.684 1.606c-.817 0-1.233.585-1.233 1.833s.416 1.828 1.233 1.828 1.227-.578 1.227-1.828-.412-1.833-1.227-1.833m0 4.366c-1.413 0-2.231-.9-2.231-2.534s.818-2.54 2.231-2.54 2.226.907 2.226 2.54-.816 2.534-2.226 2.534'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 114'
			transform='translate(-118.883 -83.229)'
		/>
		<path
			id='amais-negativo_svg__Caminho_115'
			d='M212.806 114.98a4.049 4.049 0 01-1.615-.323l.07-.786a3.041 3.041 0 001.5.4c.565 0 1-.212 1-.647 0-.464-.335-.6-1.252-.9-.766-.252-1.312-.564-1.312-1.38 0-.9.778-1.443 1.878-1.443a3.755 3.755 0 011.259.2v.764a3.379 3.379 0 00-1.228-.258c-.607 0-.977.258-.977.634 0 .393.33.534 1.108.8.918.3 1.431.615 1.431 1.473s-.673 1.461-1.865 1.461'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 115'
			transform='translate(-118.214 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_116'
			d='M217.7 114.914a1.942 1.942 0 01-.98.252 1.383 1.383 0 01-1.067-.414 1.6 1.6 0 01-.271-1.088v-2.756h-.749v-.725h.749v-1.251l.977-.292v1.544h1.157v.725h-1.148v2.691c0 .565.14.837.614.837a1.277 1.277 0 00.739-.233z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 116'
			transform='translate(-117.707 -83.197)'
		/>
		<path
			id='amais-negativo_svg__Caminho_117'
			d='M218.735 109.458a.587.587 0 01-.586-.6.578.578 0 01.586-.583.584.584 0 01.592.583.593.593 0 01-.592.6m1.119 5.519a1.2 1.2 0 01-.708.2.847.847 0 01-.666-.252 1.1 1.1 0 01-.18-.737v-3.228h-.575v-.725h1.561v3.932c0 .234.07.325.243.325a.758.758 0 00.364-.122z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 117'
			transform='translate(-117.253 -83.25)'
		/>
		<path
			id='amais-negativo_svg__Caminho_118'
			d='M223.26 111.56c-.144-.6-.4-.946-.937-.946-.829 0-1.172.767-1.172 1.765 0 1.272.464 1.884 1.413 1.884A2.666 2.666 0 00224 113.8l-.042.755a2.906 2.906 0 01-1.551.424c-1.443 0-2.25-.9-2.25-2.532 0-1.592.826-2.542 2.157-2.542a1.752 1.752 0 011.867 1.454z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 118'
			transform='translate(-116.896 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_119'
			d='M227.035 112.476a3.2 3.2 0 00-.865-.132c-.78 0-1.089.407-1.089.961a.894.894 0 00.927 1 1.077 1.077 0 00.787-.3 1.131 1.131 0 00.24-.8zm1.554 2.262a1.156 1.156 0 01-.694.2.738.738 0 01-.777-.483 1.668 1.668 0 01-1.282.523 1.567 1.567 0 01-1.743-1.634c0-1.111.757-1.685 1.946-1.685a3.579 3.579 0 011 .162v-.141a1.081 1.081 0 00-.21-.778 1.152 1.152 0 00-.918-.312 2.752 2.752 0 00-1.352.366v-.72a3.283 3.283 0 011.492-.331 2.187 2.187 0 011.594.525 1.645 1.645 0 01.384 1.2v2.3c0 .234.071.325.242.325a.75.75 0 00.362-.122z'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 119'
			transform='translate(-116.317 -83.011)'
		/>
		<path
			id='amais-negativo_svg__Caminho_120'
			d='M187.2 106.919a51.391 51.391 0 00-17.018-16.49l-.219-.132-.064-.022a29.767 29.767 0 00-14.422-3.818 26.23 26.23 0 00-9.356 1.684 24.36 24.36 0 00-8.145 5.107c-.186.172-.349.327-.5.474a25.006 25.006 0 00-7.328 16.74h-.021v1.855l.015.135a25.006 25.006 0 007.326 16.739c.149.147.312.305.5.474a24.34 24.34 0 008.147 5.11 26.256 26.256 0 009.356 1.684 29.761 29.761 0 0014.422-3.818h.026l.259-.156A51.413 51.413 0 00187.2 116a8.426 8.426 0 000-9.078'
			className='amais-negativo_svg__cls-2'
			data-name='Caminho 120'
			transform='translate(-130.128 -86.457)'
		/>
		<path
			id='amais-negativo_svg__Caminho_121'
			d='M186.337 107.266a50.58 50.58 0 00-16.718-16.2h-.013c-10.262-5.841-22.9-5.11-31.148 2.708q-.241.218-.473.451a24.118 24.118 0 00-7.088 17v.233a24.125 24.125 0 007.088 17c.155.154.312.305.473.45 8.246 7.816 20.886 8.55 31.148 2.708h.013a50.539 50.539 0 0016.718-16.2 7.543 7.543 0 000-8.156'
			className='amais-negativo_svg__cls-1'
			data-name='Caminho 121'
			transform='translate(-130.016 -85.973)'
		/>
		<path
			id='amais-negativo_svg__Caminho_122'
			d='M156.389 113.728a1.022 1.022 0 01-.305.648 3.081 3.081 0 01-.835.649 5.158 5.158 0 01-1.22.481 5.648 5.648 0 01-1.466.188 2.87 2.87 0 01-2.209-.726 2.53 2.53 0 01-.642-1.761 2.3 2.3 0 01.491-1.519 3.581 3.581 0 011.261-.965 7.236 7.236 0 011.8-.548 16.152 16.152 0 011.938-.206c.256-.015.432-.008.623-.014s.387 0 .563 0zm4.8-10.431a5.257 5.257 0 00-1.361-2.341 5.824 5.824 0 00-2.484-1.4 13.057 13.057 0 00-3.727-.551 16.431 16.431 0 00-3.013.281 12.316 12.316 0 00-2.394.725 6.812 6.812 0 00-1.86 1.035 1.411 1.411 0 00-.63 1.078 2.938 2.938 0 00.318 1.187 3.121 3.121 0 00.477.768 1.256 1.256 0 001.464.2c.748-.357.821-.387 1.592-.7a8.882 8.882 0 013.192-.552 4.416 4.416 0 012.709.658 2.673 2.673 0 01.835 2.224v.713c-.274 0-.533 0-.876.011-.311.006-.631.006-.96.034a29.314 29.314 0 00-3.15.323 11.393 11.393 0 00-3.321 1.076 7.427 7.427 0 00-2.5 2.081 5.37 5.37 0 00-1 3.37 6.356 6.356 0 00.571 2.82 5.181 5.181 0 001.464 1.847 5.809 5.809 0 002 .994 8.308 8.308 0 002.2.3 8.819 8.819 0 003.582-.651 7.385 7.385 0 002.363-1.585 2.631 2.631 0 00.983 1.649 3.555 3.555 0 002.191.571 1.608 1.608 0 001.753-1.724v-11.163a11.77 11.77 0 00-.409-3.278'
			className='amais-negativo_svg__cls-2'
			data-name='Caminho 122'
			transform='translate(-128.016 -84.613)'
		/>
		<path
			id='amais-negativo_svg__Caminho_123'
			d='M178.31 109.332a8.571 8.571 0 00-.071-1.107 1.364 1.364 0 00-1.358-1.219h-3.532a1.121 1.121 0 01-1.122-1.124v-3.53a1.364 1.364 0 00-1.22-1.357 8.245 8.245 0 00-2.213 0 1.364 1.364 0 00-1.219 1.357v3.53a1.122 1.122 0 01-1.122 1.124h-3.534a1.359 1.359 0 00-1.352 1.219 8.234 8.234 0 000 2.211 1.36 1.36 0 001.352 1.218h3.534a1.123 1.123 0 011.122 1.122v3.534a1.365 1.365 0 001.219 1.357 8.64 8.64 0 002.213 0 1.365 1.365 0 001.22-1.357v-3.534a1.121 1.121 0 011.122-1.122h3.532a1.365 1.365 0 001.358-1.218 8.576 8.576 0 00.071-1.1'
			className='amais-negativo_svg__cls-2'
			data-name='Caminho 123'
			transform='translate(-125.517 -84.331)'
		/>
	</svg>
)

export default SvgAmaisNegativo
